import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpSentEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take, finalize } from 'rxjs/operators';
import { TokenService } from '../shared/services/token.service';
import { UserService } from '../shared/services/user.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  isRefreshingToken = false;
  tokenSubject = new BehaviorSubject<string>(null);

  constructor(
    private userService: UserService,
    private tokenService: TokenService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent
    | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {

    if (req.url.includes('oauth') || req.url.includes('v1/auth/dash') || req.url.includes('ws') || req.url.includes('recuperar-senha') || req.url.includes('emails/unsubscribe')) {
      return next.handle(req);
    }

    if (this.tokenService.accessKey)
      req = this.addTokenHeader(req, this.tokenService.accessKey);
    else
      return <any>this.userService.logout();

    return next.handle(req).pipe(
      catchError(error => {
        if (error.status === 401)
          return this.handle401Error(req, next);
        else
          return throwError(error);
      })
    );
  }

  private addTokenHeader(request: HttpRequest<any>, token: string | null) {
    return request.clone({
      setHeaders: {
        'Authorization': 'Bearer ' + token
      }
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      this.tokenSubject.next(null);

      return this.tokenService.refreshToken()
        .pipe(
          switchMap(accessToken => {
            if (accessToken) {
              this.tokenSubject.next(this.tokenService.accessKey);
              return next.handle(this.addTokenHeader(request, this.tokenService.accessKey));
            } else
              return this.tokenService.removeToken();
          }),
          catchError(() => this.tokenService.removeToken()),
          finalize(() => this.isRefreshingToken = false)
        );
    } else {
      return this.tokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => next.handle(this.addTokenHeader(request, token)))
      );
    }
  }
}
